if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"TRAFFIX_UI_SHELL","remotes":[{"alias":"COMMON_APP","name":"COMMON_APP","entry":"https://app.traffix.com/common-mfe/remoteEntry.js?v=1790022162018","shareScope":"default"}]},
		chunkMatcher: function(chunkId) {return !/^(5(228|453|666)|6(050|35|843)|2040|7293|8326)$/.test(chunkId)},
		rootOutputDir: "../../",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}